export type FieldError = {
  field: string
  messageCode: string
  messageCodeParams?: Record<string, string>
}

export const findFieldError = (fieldErrors: FieldError[], fieldName: string): FieldError | undefined =>
  fieldErrors?.find((error) => error.field === fieldName)
